import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PartnerLicensePackageUsageRateGauge from './PartnerLicensePackageUsageRateGauge';
import CustomerSuccessHistoryService from '../../services/CustomerSuccessHistoryService';
import { PartnerLicensePackageUsageRateListService } from '../../services/CustomerSuccessKpiListService';

class PartnerLicensePackageUsageRateGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    PartnerLicensePackageUsageRateListService.load();
  }
  render() {
    return (
      <PartnerLicensePackageUsageRateGauge
        loading={
          PartnerLicensePackageUsageRateListService.fetchCurrent.fetching ||
          PartnerLicensePackageUsageRateListService.fetchPrevious.fetching
        }
        currentValue={toJS(PartnerLicensePackageUsageRateListService.global.current)}
        previousValue={toJS(PartnerLicensePackageUsageRateListService.global.previous)}
        onClickHistory={() => CustomerSuccessHistoryService.openDialog('PARTNER_LICENSE_PACKAGE_USAGE')}
        formatter={PartnerLicensePackageUsageRateListService.getFormattedValue}
      />
    );
  }
}

export default observer(PartnerLicensePackageUsageRateGaugeContainer);
